import * as actionTypes from "./actionTypes";
import axios from "axios";
export const toggelContactShow = (dealerId, dealerName, dealerNumber) => {
    return {
        type: actionTypes.TOGGEL_CONTACT_NOW,
        dealerId : dealerId,
        dealerName: dealerName,
        dealerNumber: dealerNumber
    }
};

export const createNewChat = (bearerToken, message, receiverId) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    };

    const data = {
        message: message,
        receiver_id: receiverId
    };

    return dispatch => {
        axios.post('chat_messages', data, config)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
            })
    }
};